import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const BellIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '60%' : '100%'}
      height={circled ? '60%' : '100%'}
      viewBox="0 0 24 23.599"
    >
      <g transform="translate(1 1)">
        <path
          d="M85.585,272.288h.5a2.016,2.016,0,1,1,0,4.032H68.127a2.016,2.016,0,1,1,0-4.032h.505a1.229,1.229,0,0,0,1.23-1.228v-5.123a7.247,7.247,0,0,1,14.493,0v5.123A1.229,1.229,0,0,0,85.585,272.288Z"
          transform="translate(-66.109 -258.7)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M80.913,276.5a3.8,3.8,0,0,1-7.609,0"
          transform="translate(-66.109 -258.7)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
